<template>
    <div class="pcr-admin-establishment-contextual-menu">
        <el-row :gutter="20">
            <el-col :span="24" v-if="current">
                <system-index :establishment-id="current.Id" v-if="current.Id == 1 && !$router.currentRoute.query.SQLAdmin"></system-index>
                <system-sql-admin v-if="showSQLAdmin"></system-sql-admin>
                <partner-index :establishment-id="current.Id" v-if="current.Id != 1 && current.Type == 'Partner'"></partner-index>
                <managing-index :establishment-id="current.Id" v-if="current.Id != 1 && current.Type == 'Managing'"></managing-index>
                <establishment-index :establishment-id="current.Id" v-if="current.Id != 1 && current.Type == 'Establishment'"></establishment-index>
                <group-index :group-id="current.Id" :zone-id="current.ParentId" v-if="current.Id != 1 && current.Type == 'Group'"></group-index>
                <user-index :user-id="current.Id" v-if="current.Id != 1 && current.Type == 'User'"></user-index>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('admin-establishment-contextual-menu', {
    props: {
        current: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            showSQLAdmin: false
        }
    },
    mounted: function() {
        this.showSQLAdmin = this.$router.currentRoute.query.SQLAdmin;
        this.$router.afterEach(() => {
            this.showSQLAdmin = this.$router.currentRoute.query.SQLAdmin;
        });
    },
    methods: {
    },
    watch: {
        current(val) {
            
        },
        '$router.currentRoute.query'(val) {
            console.log(val);
        }
    }
});
</script>

<style>
.pcr-admin {
    margin-top: 12px;
}
.el-tree {
    min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/admin-establishment-contextual.vue